/* eslint-disable no-undef */
<template>
  <div class="contact-map"></div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      map: null,
      popup: null,
      options: {
        zoom: 4,
        center: new google.maps.LatLng(46, 2.8),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#d5d9cf"
              },
              {
                lightness: 20
              }
            ]
          }
        ],
        draggable: true,
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false
      },
      markers: [],
      mapHasBeenPinned: false,
      moreListener: null,
      activeContactEl: null
    };
  },
  mounted() {
    this.map = new google.maps.Map(this.$el, this.options);
    this.popup = new google.maps.InfoWindow({
      content: "Hello"
    });
    // console.log("MPA >", this.map);
    this.$nextTick(function() {
      this.pinupMap();
    });
  },
  watch: {
    country() {
      // console.log("country changed...", this.country);
      if (this.country) {
        let vm = this;
        let lat = this.country.latlng[0],
          lng = this.country.latlng[1];
        this.map.setZoom(5);
        google.maps.event.addListenerOnce(this.map, "idle", function() {
          vm.map.setZoom(5.5);
        });
        this.map.panTo({ lat, lng });
        this.activateCountry();
        this.openMapPopup();
        // console.log('active marker >> ', activeMarker);
      }
    }
  },
  computed: {
    ...mapState(["countries"]),
    search: {
      get() {
        return this.$store.state.search;
      },
      set(value) {
        this.$store.commit("UPDATE_SEARCH", value);
      }
    },
    country() {
      if (this.search.length) {
        return _.find(this.countries, c => c.title === this.search);
      }
      return null;
    }
  },
  destroyed() {
    this.markers.forEach(marker => {
      google.maps.event.clearListeners(marker, "click");
    });
  },
  methods: {
    pinupMap() {
      // console.log("pin map!");
      if (!this.mapHasBeenPinned) {
        for (var i = 0; i < this.countries.length; i++) {
          this.addMarkerWithTimeout(this.countries[i], i * 50);
        }
        this.mapHasBeenPinned = true;
      }
    },
    activateCountry() {
      if (this.activeContactEl) {
        this.activeContactEl.classList.remove("active");
      }
      this.activeContactEl = document.getElementById(this.country.title);
      this.activeContactEl.classList.add("active");
    },
    scrollToContact(e) {
      e.preventDefault();
      // console.log("scrollToContact");
      google.maps.event.removeListener(this.moreListener);
      let continentEl = document.getElementById(this.country.continent);
      if (continentEl) {
        let elIndex = continentEl.getAttribute("panel-index");
        // console.log("continentEl >> ", elIndex);
        this.$store.commit("UPDATE_PANELS", [parseInt(elIndex)]);
      }
      setTimeout(
        function() {
          this.activateCountry();
          this.activeContactEl.scrollIntoView({
            behavior: "smooth",
            block: "center"
          });
        }.bind(this),
        1200
      );
    },
    openMapPopup(country) {
      if (country) {
        this.$set(this, "search", country.title);
      } else {
        country = this.country;
      }
      let marker = _.find(this.markers, { title: country.title });

      // console.log("country clicked >> ", marker);

      var popContent = `
                    <div class="text-left">
                    <h5 class="text--s mb-xs font-600">${country.title}</h5>
                    <p class="text--xs">${country.description}</p>
                    <a id="more" class="pt-s block" href="#p">${this.localize(
                      "More info"
                    )}</a>
                    </div>
                  `;
      this.popup.setContent(popContent);
      this.popup.open(this.map, marker.mark);
      this.$nextTick(function() {
        setTimeout(
          function() {
            let el = document.getElementById("more");
            this.moreListener = google.maps.event.addDomListener(
              el,
              "click",
              this.scrollToContact
            );
          }.bind(this),
          0
        );
      });
    },
    addMarkerWithTimeout(country, timeout) {
      const vm = this;
      if (country.latlng) {
        setTimeout(
          function() {
            var marker_data = {
              position: new google.maps.LatLng(
                country.latlng[0],
                country.latlng[1]
              ),
              icon: {
                url: "/img/mis-map-pin.png",
                scaledSize: new google.maps.Size(34, 40)
              },
              optimized: false,
              map: this.map,
              title: country.title
            };
            if (window.chrome) {
              marker_data.animation = google.maps.Animation.DROP;
            }
            let _event = "click"; //$device.mobile ? "dblclick" :
            this.markers.push(
              (function() {
                let title = country.title,
                  mark = new google.maps.Marker(marker_data),
                  listener = mark.addListener(_event, function(e) {
                    // console.log("this << ", this);
                    vm.openMapPopup(country);
                  });
                return {
                  title,
                  mark,
                  listener
                };
              })()
            );
          }.bind(this),
          timeout
        );
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.contact-map
    min-height 50vh
    background #fff
    border-top 1px solid gray_3
    border-bottom 1px solid gray_3
</style>
